
import { Component, Vue } from "vue-property-decorator";
import Tabs from "@/components/Tabs/Tabs.vue";
import { TTab } from "@/models/tabs";
import { employeeProfileLinks } from "./REmployeeProfile";
import { SMUser } from "@/store";

@Component({
  components: {
    Tabs,
  },
})
export default class Profile extends Vue {
  get tabs(): TTab[] {
    return employeeProfileLinks.map(({ path, label }) => ({
      path: SMUser.basePath + path,
      label: label.toUpperCase(),
      isActive: this.$route.path.includes(path),
    }));
  }
}
